import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconWallpaper: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="wallpaper, os"><path d="M3 13.4232C5.07915 12.3217 9.2393 9.75 12 9.75C14.7607 9.75 18.9208 12.3217 21 13.4232M11.735 10.1127C11.1067 11.01 9.63873 13.3504 10.4583 14.5893C11.4861 16.1429 16.0676 13.8961 16.625 16.1429C16.9749 17.5532 15.1808 18.4834 14 18.9335M2.75 4.75H21.25V19.25H13.0278H2.75V4.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconWallpaper;
